import { SpriteFrame } from './SpriteFrame';
import { Vector2 } from './Vector2';
import { Rect } from './Rect';

export class NinePatchFrame extends SpriteFrame {
  ninePatch: Rect;

  constructor(srcRect: Rect, offset: Vector2, size: Vector2, ninePatch: Rect) {
    super(srcRect, offset, size);
    this.ninePatch = ninePatch;
  }
}
